import React from 'react'
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaPaperPlane,
  FaTruckMoving,

  FaHardHat,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import {

  FaSeedling,
  FaLeaf,

} from "react-icons/fa";
import { GiPlantRoots, GiFarmer } from "react-icons/gi";

import {
  GiWheat,
  GiFarmTractor,
  GiCorn,
} from "react-icons/gi";

import {
  MdAgriculture,
} from "react-icons/md";
import { FaTractor, FaTruck } from "react-icons/fa";



const About = () => {
    
  return (
  
    <>
       <section
  className="position-relative d-flex align-items-center justify-content-center text-center text-white"
  style={{
    backgroundImage:
      "linear-gradient(rgba(0,0,0,.65), rgba(0,0,0,.65)), url('https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=1600&auto=format&fit=crop')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "420px",
  }}
>
  <Container>

    <div className="d-flex justify-content-center gap-3 fs-2 mb-3">
      <FaTruckMoving />
      <FaTractor />
      <FaHardHat />
    </div>

    <div
      className="mx-auto mb-4"
      style={{
        width: "70px",
        height: "4px",
        background: "var(--primary-color)",
      }}
    ></div>

    <h1 className="display-3 fw-bold mb-3">
      About Us
    </h1>

 <nav
  className="d-inline-flex align-items-center px-4 py-2"
  style={{ background: "var(--primary-color)" }}
>
  <Link
    to="/"
    className="text-white text-decoration-none fw-semibold"
  >
    Home
  </Link>

  <span className="mx-2 text-white">/</span>

  <span className="text-white">About Us</span>
</nav>

  </Container>
</section>


<section className="py-5 bg-white">
  <Container>
    <Row className="align-items-center g-5">

     
   <Col lg={6}>
  <div className="position-relative overflow-hidden">

          <img
            src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=900&auto=format&fit=crop"
            alt="Construction"
            className="img-fluid rounded shadow"
          />

          <img
            src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=700&auto=format&fit=crop"
            alt="Equipment"
            className="img-fluid rounded shadow position-absolute"
            style={{
              width: "45%",
              bottom: "-30px",
              right: "0px",
              border: "8px solid #fff",
            }}
          />

        </div>
      </Col>

      
      <Col lg={6}>

        <span
          className="fw-semibold"
          style={{ color: "var(--primary-color)" }}
        >
          ABOUT KRIMOTION
        </span>

        <h2 className="display-5 fw-bold my-3">
        Platform Designed For Connecting
          <br />
         Drivers, Dealers, And
          <br />
         Customers
        </h2>

        <div
          className="mb-4"
          style={{
            width: "70px",
            height: "4px",
            background: "var(--primary-color)",
          }}
        ></div>

        {/* <p className="text-muted mb-4">
          Krimotion is a powerful digital platform designed to simplify and strengthen the agricultural machinery ecosystem by connecting drivers, dealers, and customers on a single platform
        </p> */}

        {/* <p className="text-muted mb-4">
  Krimotion is a digital platform designed to simplify and strengthen the
  agricultural machinery ecosystem by connecting drivers, dealers, and
  customers on a single platform. Krimotion is operated by KISAN AGRO
  IMPLEMENTS, with its operations based at [FULL OPERATING ADDRESS].
  Our platform represents  KISAN AGRO  IMPLEMENTS and provides
  agricultural machinery, implements, and related services to customers
  and dealers.
</p> */}

<p className="text-muted mb-4">
  Krimotion is a digital platform designed to simplify and strengthen the
  agricultural machinery ecosystem by connecting drivers, dealers, and
  customers on a single platform. Krimotion is operated by{" "}
  <strong>Kisan Agro Implements</strong>, a firm specializing primarily in
  agricultural harvesting machinery, implements, and related services. The
  firm works mainly in the harvesting sector, machinery owners, dealers,
  and operators in their day-to-day agricultural operations. Kisan Agro
  Implements is a registered business with GSTIN{" "}
  <strong>09JCRPS9519G1Z</strong>. Through Krimotion, Kisan Agro Implements
  aims to make agricultural machinery services more accessible, efficient,
  and convenient by bringing customers, dealers, and machinery operators
  together on one platform.
</p>



        <Row className="g-4">

          <Col sm={6}>
            <div className="border-start border-4 ps-3">
              <h5 className="fw-bold">
                Modern Technology
              </h5>

              <p className="text-muted mb-0">
                 We specialize in providing advanced harvesters, agricultural machines, and genuine spare parts designed to improve productivity, reduce downtime, and support modern farming needs.
              </p>
            </div>
          </Col>

          <Col sm={6}>
            <div className="border-start border-4 ps-3">
              <h5 className="fw-bold">
                Customer Support
              </h5>

              <p className="text-muted mb-0">
                Krimotion, customers can access reliable machine services, dealers can expand their reach, and drivers can connect with more opportunities.
              </p>
            </div>
          </Col>

        </Row>

     

      </Col>

    </Row>
  </Container>
</section>
<section className="py-5 bg-light">
  <Container>

    <div className="text-center mb-5">
      <span
        className="fw-semibold"
        style={{ color: "var(--primary-color)" }}
      >
        WHY CHOOSE US
      </span>

      <h2 className="display-5 fw-bold mt-2">
        Why Customers Choose KRIMOTION
      </h2>
    </div>

    <Row className="g-4">

      <Col md={6} lg={3}>
        <Card className="border-0 shadow h-100 text-center p-4">
          <h1 style={{ color: "var(--primary-color)" }}>01</h1>
          <h5 className="fw-bold">For Customers</h5>
          <p className="text-muted">
            Easily find and connect with trusted dealers and skilled drivers for agricultural machinery services.
          </p>
        </Card>
      </Col>

      <Col md={6} lg={3}>
        <Card className="border-0 shadow h-100 text-center p-4">
          <h1 style={{ color: "var(--primary-color)" }}>02</h1>
          <h5 className="fw-bold">For Dealers</h5>
          <p className="text-muted">
           Grow your business, manage customer connections, and reach more users through a digital marketplace.
          </p>
        </Card>
      </Col>

   

      <Col md={6} lg={3}>
        <Card className="border-0 shadow h-100 text-center p-4">
          <h1 style={{ color: "var(--primary-color)" }}>03</h1>
          <h5 className="fw-bold">For Drivers</h5>
          <p className="text-muted">
          Discover work opportunities, connect with customers, and improve service availability.
          </p>
        </Card>
      </Col>

         <Col md={6} lg={3}>
        <Card className="border-0 shadow h-100 text-center p-4">
          <h1 style={{ color: "var(--primary-color)" }}>04</h1>
          <h5 className="fw-bold">Customer Support</h5>
          <p className="text-muted">
         Dedicated assistance whenever you need it.
          </p>
        </Card>
      </Col>

    </Row>
  </Container>
</section>

<section className="py-5 bg-light">
  <Container>

    <div className="text-center mb-5">
      <span
        className="fw-semibold"
        style={{ color: "var(--primary-color)" }}
      >
        OUR SERVICES
      </span>

      <h2 className="fw-bold display-5 mt-2">
        Agriculture Equipment Rental Services
      </h2>

      <p
        className="text-muted mx-auto"
        style={{ maxWidth: "700px" }}
      >
        We provide advanced agricultural machinery and reliable rental
        services to improve farming productivity while reducing costs.
      </p>
    </div>

    <Row className="g-4">


      <Col lg={4} md={6}>
        <Card className="border-0 shadow text-center h-100 p-4">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
            style={{
              width: "80px",
              height: "80px",
              background: "var(--primary-color)",
              color: "#fff",
            }}
          >
            <FaTractor size={36} />
          </div>

          <h4 className="fw-bold">
            Tractor Rental
          </h4>

          <p className="text-muted mb-0">
            Powerful tractors available for ploughing, cultivation and
            transportation work.
          </p>
        </Card>
      </Col>

      
      <Col lg={4} md={6}>
        <Card className="border-0 shadow text-center h-100 p-4">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
            style={{
              width: "80px",
              height: "80px",
              background: "var(--primary-color)",
              color: "#fff",
            }}
          >
            <MdAgriculture size={38} />
          </div>

          <h4 className="fw-bold">
            Harvester Rental
          </h4>

          <p className="text-muted mb-0">
            Efficient harvesting equipment that saves time and labour
            during crop season.
          </p>
        </Card>
      </Col>

      
      <Col lg={4} md={6}>
        <Card className="border-0 shadow text-center h-100 p-4">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
            style={{
              width: "80px",
              height: "80px",
              background: "var(--primary-color)",
              color: "#fff",
            }}
          >
            <GiWheat size={36} />
          </div>

          <h4 className="fw-bold">
            Crop Harvesting
          </h4>

          <p className="text-muted mb-0">
            Professional harvesting services for wheat, rice, maize and
            seasonal crops.
          </p>
        </Card>
      </Col>

   
      <Col lg={4} md={6}>
        <Card className="border-0 shadow text-center h-100 p-4">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
            style={{
              width: "80px",
              height: "80px",
              background: "var(--primary-color)",
              color: "#fff",
            }}
          >
            <FaTruck size={34} />
          </div>

          <h4 className="fw-bold">
            Farm Transport
          </h4>

          <p className="text-muted mb-0">
            Safe transportation of crops, fertilizers and agricultural
            machinery.
          </p>
        </Card>
      </Col>

    
      <Col lg={4} md={6}>
        <Card className="border-0 shadow text-center h-100 p-4">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
            style={{
              width: "80px",
              height: "80px",
              background: "var(--primary-color)",
              color: "#fff",
            }}
          >
            <GiPlantRoots size={36} />
          </div>

          <h4 className="fw-bold">
            Soil Preparation
          </h4>

          <p className="text-muted mb-0">
            Land preparation services for better soil health and higher
            agricultural productivity.
          </p>
        </Card>
      </Col>

     
      <Col lg={4} md={6}>
        <Card className="border-0 shadow text-center h-100 p-4">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
            style={{
              width: "80px",
              height: "80px",
              background: "var(--primary-color)",
              color: "#fff",
            }}
          >
            <GiFarmer size={36} />
          </div>

          <h4 className="fw-bold">
            Expert Farmer Support
          </h4>

          <p className="text-muted mb-0">
            Experienced professionals provide guidance for selecting the
            right agricultural equipment.
          </p>
        </Card>
      </Col>

    </Row>

  </Container>
</section>
    </>
  )
}

export default About
